import { StaffMemberPhoto } from '../models';
import { supportApiHttp } from '../support-api';

export const getStaffMemberPhoto = async (
  take?: number,
  dimensions?: number
): Promise<StaffMemberPhoto[]> => {
  const response = await supportApiHttp.get<StaffMemberPhoto[]>(
    `api/staff/photos?take=${take}&dimensions=${dimensions}`
  );
  return response.data;
};
